import axios from '@/libs/api.request'
export const home = {
  getHomeInfo: (params) => {
    return axios.request({
      url: 'index/index',
      data: params,
      method: 'post'
    })
  },
  businessList: (params) => {
    return axios.request({
      url: 'index/businessList',
      data: params,
      method: 'post'
    })
  },
  noticeList: (params) => {
    return axios.request({
      url: 'index/noticeList',
      data: params,
      method: 'post'
    })
  },
  actList: (params) => {
    return axios.request({
      url: 'index/activityList',
      data: params,
      method: 'post'
    })
  },
  actDetail: (params) => {
    return axios.request({
      url: 'index/activityDetail',
      data: params,
      method: 'post'
    })
  },
  noticeDetail: (params) => {
    return axios.request({
      url: 'index/noticeDetail',
      data: params,
      method: 'post'
    })
  },
  getSystemStatus: (params) => {
    return axios.request({
      url: 'index/getSystemStatus',
      data: params,
      method: 'post'
    })
  }, 
  customerCenter: (params) => {
    return axios.request({
      url: 'index/customerCenter',
      data: params,
      method: 'post'
    })
  },
  noticeLast: (params) => {
    return axios.request({
      url: 'index/noticeLast',
      data: params,
      method: 'post'
    })
  },           
}



// WEBPACK FOOTER //
// ./src/service/api/home.js